import { createContext } from 'react';
// 组件前缀
export const Prefix = 'material';

export const PublicContent = createContext({});
